/**
 * @module config-bb-module-loader
 *
 * @description
 * Configuration module for the SystemJS module loader
 *
 * This configuration module is intended to be replaced and overwritten per project. It is used
 * to customize the SystemJS Module loader, which can be used to both lazy-load modules demand and
 * to locate modules within optimized bundles.
 *
 * The full power of SystemJS is available and the documentation on its configuration can be found
 * on the project's page, specifically
 * https://github.com/systemjs/systemjs/blob/0.19.38/docs/config-api.md
 *
 * The default implementation in this module lazy-loads all modules based on the naming convention
 * that is compatible with other tooling (`bb-package`) and the default CXP file structure.
 *
 * E.g.
 * Loading `lib-bb-i18n-ng`
 * -> `<RESOURCE_ROOT>/static/features/[BBHOST]/lib-bb-i18n-ng/scripts/lib-bb-i18n-ng.js`
 *
 * Loading `widget-bb-sample-ng`
 * -> `<RESOURCE_ROOT>/static/widgets/[BBHOST]/widget-bb-example-ng/scripts/widget-bb-sample-ng.js`
 *
 * Loading `config-bb-locale/assets/custom-locale.json`
 * -> `<RESOURCE_ROOT>/static/features/[BBHOST]/config-bb-locale/assets/custom-locale.json`
 *
 * Where `RESOURCE_ROOT` is configured on the portal server
 *
 * The default implementation is generated by the [@bb-cli/bb-bundle](http://npmjs.com/package/@bb-cli/bb-bundle)
 * tool. It's recommended that you also use this tool to generate your own config as it will
 * allow you to create concatted and minified JS bundles.
 */

import pageConfig from './page';
import systemJsConfig from './system';
import bundleDefinition from './bundle';

const systemConfig = systemJsConfig(pageConfig(), bundleDefinition);
System.config(systemConfig);



// WEBPACK FOOTER //
// ./config-bb-module-loader/scripts/index.js